import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import chicchic_login_logo from "../../assets/chicchic_login_logo.png";
import "../../shared/styles/Footer.css";
import { useAuth } from "../auth/AuthProvider";

import { FaFacebookF, FaInstagram } from "react-icons/fa";

function Footer() {
  const { user } = useAuth();
  const affiliateApplyState = user
    ? undefined
    : { from: { pathname: "/account/affiliate/apply" } };

  return (
    <>
      <br />
      <br />

      {/* ส่วนบน: ลิงก์หมวดหมู่ */}
      <Container fluid className="footer-top-dark">
        <br />

        <Container>
          <Row className="footer-top-row">
            <Col sm style={{ marginBottom: 30 }}>
              <p>
                <strong>การใช้งานและนโยบาย</strong>
              </p>

              <NavLink to="/terms" className="footer-link">
                ข้อกำหนดการให้บริการ
              </NavLink>
              <br />

              <NavLink to="/privacy" className="footer-link">
                นโยบายความเป็นส่วนตัว
              </NavLink>
              <br />
              <NavLink to="/help" className="footer-link">
                ศูนย์ช่วยเหลือ
              </NavLink>
              <br />
            </Col>

            <Col sm style={{ marginBottom: 30 }}>
              <p>
                <strong>เกี่ยวกับ ChicChic</strong>
              </p>

              <NavLink to="/about" className="footer-link">
                เกี่ยวกับ ChicChic
              </NavLink>
              <br />

              <NavLink
                to={user ? "/account/affiliate/apply" : "/login"}
                state={affiliateApplyState}
                className="footer-link"
              >
                สมัคร Affiliate
              </NavLink>
              <br />

              <NavLink to="/contact" className="footer-link">
                ติดต่อเรา
              </NavLink>
            </Col>

            <Col sm />
            <Col sm />
          </Row>
        </Container>
      </Container>

      {/* ส่วนล่าง: โลโก้ / ลิขสิทธิ์ / Social */}
      <Container fluid className="footer-bottom-gradient">
        <Container>
          <br />
          <Row className="align-items-center">
            <Col sm>
              <a href="/">
                <img
                  src={chicchic_login_logo}
                  width="60"
                  className="d-inline-block"
                  alt=""
                />
              </a>
            </Col>

            <Col sm style={{ marginTop: 8, color: "black" }}>
              <p className="footer-copy">
                © 2026 ChicChic LawTutor. All Rights Reserved.
              </p>
            </Col>

            <Col />
            <Col
              sm
              className="justify-content-end"
              style={{
                marginTop: 8,
                display: "flex",
                justifyContent: "right",
                gap: "20px",
              }}
            >
              <a
                href="https://web.facebook.com/lawlandd/about?_rdc=1&_rdr#"
                target="_blank"
                rel="noreferrer"
                className="footer-social-link"
              >
                <FaFacebookF />
              </a>

              {/* <a
                href="https://www.instagram.com/encraft_org"
                target="_blank"
                rel="noreferrer"
                className="footer-social-link"
              >
                <FaInstagram />
              </a> */}
            </Col>
          </Row>
          <br />
        </Container>
      </Container>
    </>
  );
}

export default Footer;
